import constants from 'src/constants';
import { get as lodashGet } from 'lodash';

const { SEGMENTS, MAIN_MATERIALS, UNITS } = constants.measure;
const defaultUnit = UNITS.feet.abbreviation;

/**
 *
 * Validate whether a valid number exists on an object.
 * @param {object} obj - example: area
 * @param {number} obj.someNumber - example: area.feet
 * @param {string} property - examples: feet, inch, meter
 * @returns {bool}
 */
const isValidNestedNumber = (obj, property) => {
  const value = lodashGet(obj, property);
  if (value === undefined) return false;
  if (typeof value !== 'number') return false;
  return true;
};

/**
 * @param {string} categoryName
 * @returns {bool}
 */
const isSegmentsCategory = (categoryName) =>
  !!Object.values(SEGMENTS).includes(categoryName);

/**
 * @param {string} categoryName
 * @returns {bool}
 */
const isMainMaterialCategory = (categoryName) =>
  !!Object.values(MAIN_MATERIALS).includes(categoryName);

/**
 * @param {array} items
 * @returns {array}
 */
const flattenSegmentsItems = (items) =>
  items.reduce((flattenedArray, item) => {
    const newFlattenedArray = [...flattenedArray, ...item.edges];
    return newFlattenedArray;
  }, []);

/**
 * @param {number} number
 * @param {string} [unit] e.g. ft, ', in, "
 * @param {boolean} boolean whether or not to display values less than 0.5 as < 0.5
 * @returns {string}
 */
const roundAndFormatNumber = (number, unit = defaultUnit, noZeroRounding = false) => {
  const roundedNumber = Math.round(number);
  const roundedValueString = noZeroRounding && number > 0 && roundedNumber === 0 ?
    `< ${0.5.toLocaleString()}`
    : roundedNumber.toLocaleString();
  return `${roundedValueString}${unit}`
}

export default {
  flattenSegmentsItems,
  isMainMaterialCategory,
  isSegmentsCategory,
  isValidNestedNumber,
  roundAndFormatNumber,
};
